var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22C19.3137 22 22 19.3137 22 16C22 12.6863 19.3137 10 16 10C12.6863 10 10 12.6863 10 16C10 19.3137 12.6863 22 16 22ZM16.75 20C16.75 20.4142 16.4142 20.75 16 20.75C15.5858 20.75 15.25 20.4142 15.25 20V13.8107L13.5303 15.5303C13.2374 15.8232 12.7626 15.8232 12.4697 15.5303C12.1768 15.2374 12.1768 14.7626 12.4697 14.4697L15.4697 11.4697C15.7626 11.1768 16.2374 11.1768 16.5303 11.4697L19.5303 14.4697C19.8232 14.7626 19.8232 15.2374 19.5303 15.5303C19.2374 15.8232 18.7626 15.8232 18.4697 15.5303L16.75 13.8107V20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76962 18C8.59388 17.3633 8.5 16.6926 8.5 16C8.5 11.8579 11.8579 8.5 16 8.5C18.4534 8.5 20.6317 9.67801 22 11.4993V7C22 5.89543 21.1046 5 20 5H13.8284C13.298 5 12.7893 4.78929 12.4142 4.41421L10.5858 2.58579C10.2107 2.21071 9.70201 2 9.17157 2H4C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H8.76962Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.3f5e56d1996c0dc7618a596b9d9cf302.svg";
export { ForwardRef as ReactComponent };